<script setup lang="ts">
const {
  text,
  animated = true,
  type = 'scribble',
} = defineProps<{
  text: string
  animated?: boolean
  type?: 'scribble' | 'single-line'
}>()

const paths = {
  // Full back-and-forth scribble
  scribble: 'M-300,-56 C-50,-72 298,-65 300,-59 C332,-53 -239,-36 -255,-27 C-271,-18 -88,-24 91,-20',
  // Just the top line of the scribble
  'single-line': 'M-300,-56 C-50,-72 298,-65 300,-59',
}

const path = computed(() => paths[type])
</script>

<template>
  <span class="container">
    {{ text }}
    <svg viewBox="-320 -70.8161 640.4 59.82" preserveAspectRatio="none">
      <path
        :class="{ animated }"
        :d="path"
        stroke="var(--primary)"
        pathLength="1"
        stroke-width="11.111111111111"
        fill="none"
      ></path>
    </svg>
  </span>
</template>

<style lang="scss" scoped>
.container {
  display: inline-block;
  position: relative;
  line-height: 1;
}

svg {
  position: absolute;
  bottom: -0.6em;
  left: 0;
  width: 100%;
  height: 0.6em;
  overflow: visible;

  path {
    stroke-dasharray: 1;
    stroke-dashoffset: 0;
    stroke-linecap: round;

    &.animated {
      stroke-dashoffset: 1;
      // Butt cap while hidden so the zero-length dash doesn't show as a dot before drawing
      stroke-linecap: butt;
      animation: 1s drawScribble 750ms ease-in-out forwards;
    }
  }
}

@keyframes drawScribble {
  to {
    stroke-dashoffset: 0;
    stroke-linecap: round;
  }
}
</style>
